function vimeoPlayer_setup(player, video, autoplay) {
  var videoItem = video.parent("li"),
    videoID = videoItem.find("a").attr("href").replace("#", ""),
    videoWidth = videoItem.attr("data-width"),
    videoHeight = videoItem.attr("data-height");

  if (autoplay === true) {
    autoplay = "&autoplay=1";
  } else {
    autoplay = "";
  }

  player.find(".video-list .active").removeClass("active");
  videoItem.addClass("active");
  player
    .find(".video-frame .video")
    .html(
      '<iframe ' +
        'id="iframe-video"' +
        'src="https://player.vimeo.com/video/' + videoID + "?title=0&byline=0&portrait=0" + autoplay + '"' +
        'width="' + videoWidth + 'px" ' +
        'height="' + videoHeight + 'px" ' +
        'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen' + 
      '></iframe>'
    )
    .parent()
    .fitVids();

  // Show loading until video is ready
  player.find("#iframe-video").on("load", function() {
    player.removeClass("loading");
  });
}

function vimeoPlayer_noDomScroll(player) {
  if (player.width() >= 768) {
    // console.log("Desktop");
    player
      .removeClass("mobile-view")
      .find(".video-list")
      .hover(function() {
        $("body").toggleClass("no-scroll");
      });
  } else {
    // console.log("Mobile");
    player.addClass("mobile-view");
  }
}



function init() {
  
  // Shortcode - Vimeo Player
  if ($(".vimeoPlayer").length > 0) {
    // console.log("_Init vimeoPlayer");
    var vimeoPlayer = $(".vimeoPlayer");

    if ($(".vimeoPlayer")) {
      vimeoPlayer.each(function() {
        var player = $(this),
            firstVideo = player.find(".video-list li:first-of-type a");

        if (player.find(".video-list li").length <= 1) {
          player.addClass("single");
        }

        // Setup first video
        vimeoPlayer_setup(player, firstVideo);

        setTimeout(function() {
          player.addClass("ready");
        }, 1500);

        player.find(".video-list li a").on("click", function(e) {
          player.addClass("loading");
          vimeoPlayer_setup(player, $(this), true);
          e.preventDefault();
        });

        // Scroll only video list on hover
        $(window).resize(function() {
          vimeoPlayer_noDomScroll(player);
        });

        vimeoPlayer_noDomScroll(player);
      });
    }
  }

}

module.exports = { init };